/**
 * Exportador Global del Modal Selector de Prefijo de WhatsApp
 * Centralizado en el directorio compartido para uso en Onboarding, Login, Configuración de Perfil, etc.
 */

export {
  PrefijoWhatsappModalSelector,
  type PrefijoWhatsappModalSelectorProps,
  type PrefijoWhatsappItem,
} from '@/modulos/onboarding_clientes/components/PrefijoWhatsappModalSelector';
